import { Injectable, Signal, signal } from '@angular/core';

export interface TocSection {
  title: string;
  id: string;
}

@Injectable({ providedIn: 'root' })
export class LegalTocService {
  private readonly sectionsSignal = signal<TocSection[]>([]);
  readonly sections: Signal<TocSection[]> = this.sectionsSignal.asReadonly();

  setSections(sections: TocSection[]): void {
    this.sectionsSignal.set(sections);
  }

  clear(): void {
    this.sectionsSignal.set([]);
  }
}
